module.exports = __webpack_public_path__ + "img/T6-B-4.29b89314.png";